
import AdsCommonPanel from '../components/AdsCommonPanel/V2';
import {ENGINEERS_WEEK} from '@jobseeker/common-core/constants';
import {AppState} from '@jobseeker/common-core/types';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks/common';
import {shallowEqual, useSelector} from 'react-redux';

export type AdsCommonWidgetProps = {
  variant: VersionVariants;
  showSmallBadges: boolean;
  showLearningCenterCTA: boolean;
  profileDropdown?: any;
  showFeatured?: boolean;
  showLearning?: boolean;
  showLearnGrow?: boolean;
  showEventOnly?: boolean;
  showFeaturedInstitute?: boolean;
  showRolesAtLeadingBrands?: boolean;
  showPlatinumPartners?: boolean;
  page?: string;
  showSalesEvent?: boolean;
  showGoldPartners?: boolean;
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const AdsPanel = ({
  variant,
  showSmallBadges,
  profileDropdown,
  showFeatured = true,
  showLearning = false,
  showLearnGrow = true,
  showEventOnly = false,
  showFeaturedInstitute = true,
  showRolesAtLeadingBrands = false,
  showPlatinumPartners = false,
  showGoldPartners = false,
  showSalesEvent = false,
  page,
  showLearningCenterCTA,
}: AdsCommonWidgetProps) => {
  const isLarge = useIsLargeDevice();
  if (page === ENGINEERS_WEEK) {
    return (
      <AdsCommonPanel
        showFeaturedInstitute={showFeaturedInstitute}
        showRolesAtLeadingBrands={showRolesAtLeadingBrands}
        showPlatinumPartners={showPlatinumPartners}
        showGoldPartners={showGoldPartners}
        showSalesEvent={showSalesEvent}
        showLearnGrow={showLearnGrow}
        showFeatured={showFeatured}
        showLearning={showLearning}
        profileDropdown={profileDropdown}
        showSmallBadges={showSmallBadges}
        showLearningCenterCTA={showLearningCenterCTA}
        showEventOnly={showEventOnly}
        page={page}
      />
    );
  }

  return !isAppIimjobs && !isLarge ? (
    <></>
  ) : (
    <AdsCommonPanel
      showFeaturedInstitute={showFeaturedInstitute}
      showRolesAtLeadingBrands={showRolesAtLeadingBrands}
      showPlatinumPartners={showPlatinumPartners}
      showGoldPartners={showGoldPartners}
      showSalesEvent={showSalesEvent}
      showLearnGrow={showLearnGrow}
      showFeatured={showFeatured}
      showLearning={showLearning}
      profileDropdown={profileDropdown}
      showSmallBadges={showSmallBadges}
      showLearningCenterCTA={showLearningCenterCTA}
      showEventOnly={showEventOnly}
      page={page}
    />
  );
};

export default AdsPanel;
